import BreadCrumb from 'Components/Common/BreadCrumb'
import React, { useState } from 'react'
import { Card, Container, Input } from 'reactstrap'
import "./Variants.scss"
import Mobile from "../../../../../assets/images/iphone-6s-32gb-price-in-pakistan.jpg"
import { useNavigate } from 'react-router-dom';
import VariantcolorModal from './variantcolorModal'
import VariantstorageModal from './variantstorageModal'


const VariantsPages = () => {
    const navigate = useNavigate();
     const [variantcolorModal, setvariantcolorModal] = useState<boolean>(false);
     const [variantstorageModal, setvariantstorageModal] = useState<boolean>(false);



  return (

<div className="page-content">
  <VariantcolorModal
    show={variantcolorModal}
    onCloseClick={() => setvariantcolorModal(false)}
  />
  <VariantstorageModal
    show={variantstorageModal}
    onCloseClick={() => setvariantstorageModal(false)}
  />

  <Container fluid>
    <BreadCrumb title="Variant" pageTitle="Ecommerce Products" />

    <div className='Main-Content-Variants'>
      <Card>
        <div className='color-family-container'>
          <div className="color-family-section">
            <label className="label">
              Color Family <span className="required">*</span>
            </label>

            <div className="image-upload-section">
              <div className="images-preview">
                <img src={Mobile} alt="color-option" />
                <img src={Mobile} alt="color-option" />
              </div>
              <button className="add-image-btn">+</button>
            </div>

            <label className="radio-label">
              <input type="radio" name="upload" defaultChecked />
              Add Image
            </label>

            <div className="color-tags">
              <span className="tag">Blue <span className="remove">×</span></span>
              <span className="tag">Red <span className="remove">×</span></span>
              <button className="add-colors-btn" onClick={() => setvariantcolorModal(true)}>Add Colors</button>
            </div>
          </div>
        </div>
      </Card>

      <Card>
        <div className='color-family-container'>
          <div className="color-family-section">
            <label className="label">
              Storage Capacity <span className="required">*</span>
            </label>

            <label className="radio-label">
              <input type="radio" name="upload" defaultChecked />
              Add Image
            </label>

            <div className="color-tags">
              <span className="tag">64GB <span className="remove">×</span></span>
              <span className="tag">128GB <span className="remove">×</span></span>
              <button className="add-colors-btn" onClick={() => setvariantstorageModal(true)}>Add Storage</button>
            </div>
          </div>
        </div>
      </Card>

      <div className="price-stock-container">
        <button className="next-btn" onClick={() => navigate('/product/add/Variants-Detail')}>Next: Price & Stock</button>
      </div>
    </div>
  </Container>
</div>

  )
}


export default VariantsPages
function setModal(arg0: boolean) {
  throw new Error('Function not implemented.')
}

function setIsEdit(arg0: boolean) {
  throw new Error('Function not implemented.')
}

function setActiveModal(modalType: string) {
  throw new Error('Function not implemented.')
}

